/**
 * 专栏
 * 专栏API
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The ColumnBaseVo model module.
   * @module column/model/ColumnBaseVo
   * @version 0.1.0
   */

  /**
   * Constructs a new <code>ColumnBaseVo</code>.
   * @alias module:column/model/ColumnBaseVo
   * @class
   * @param id {Integer} id
   * @param title {String} 专栏标题
   * @param type {Integer} 专栏类型 1:数字课堂 2:数字资源 3:知识服务
   * @param free {Boolean} 是否免费 true:免费 false:收费
   * @param status {Integer} 状态 0:禁用 1:启用
   */
  var exports = function(id, title, type, free, status) {
    var _this = this;

    _this['id'] = id;
    _this['title'] = title;
    _this['type'] = type;

    _this['free'] = free;

    _this['status'] = status;





  };

  /**
   * Constructs a <code>ColumnBaseVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:column/model/ColumnBaseVo} obj Optional instance to populate.
   * @return {module:column/model/ColumnBaseVo} The populated <code>ColumnBaseVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'thumbUrl')) {
        obj['thumbUrl'] = ApiClient.convertToType(data['thumbUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'free')) {
        obj['free'] = ApiClient.convertToType(data['free'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'price')) {
        obj['price'] = ApiClient.convertToType(data['price'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sortKey')) {
        obj['sortKey'] = ApiClient.convertToType(data['sortKey'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtCreate')) {
        obj['gmtCreate'] = ApiClient.convertToType(data['gmtCreate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtModified')) {
        obj['gmtModified'] = ApiClient.convertToType(data['gmtModified'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'createAccountId')) {
        obj['createAccountId'] = ApiClient.convertToType(data['createAccountId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'modifyAccountId')) {
        obj['modifyAccountId'] = ApiClient.convertToType(data['modifyAccountId'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 专栏标题
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 专栏类型 1:数字课堂 2:数字资源 3:知识服务
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;
  /**
   * 封面图URL
   * @member {String} thumbUrl
   */
  exports.prototype['thumbUrl'] = undefined;
  /**
   * 是否免费 true:免费 false:收费
   * @member {Boolean} free
   */
  exports.prototype['free'] = undefined;
  /**
   * 价格，单位分
   * @member {Integer} price
   */
  exports.prototype['price'] = undefined;
  /**
   * 状态 0:禁用 1:启用
   * @member {Integer} status
   */
  exports.prototype['status'] = undefined;
  /**
   * 排序
   * @member {Integer} sortKey
   */
  exports.prototype['sortKey'] = undefined;
  /**
   * 创建时间
   * @member {Date} gmtCreate
   */
  exports.prototype['gmtCreate'] = undefined;
  /**
   * 更新时间
   * @member {Date} gmtModified
   */
  exports.prototype['gmtModified'] = undefined;
  /**
   * 创建者ID
   * @member {Integer} createAccountId
   */
  exports.prototype['createAccountId'] = undefined;
  /**
   * 最后修改者ID
   * @member {Integer} modifyAccountId
   */
  exports.prototype['modifyAccountId'] = undefined;



  export default exports;
;


